// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "primeui." + {"163":"4d8528f437e36c906c01","241":"c67c8800715bab62e38b","306":"dae634a3e3b861acf578","466":"46713e76bb826d0d7ff3","620":"5159dc4024049c73f035","646":"1e195e1626735ed65ddf","726":"ffc23368c31acf3c8030","762":"3a0f49c4fda4eb6112b9","985":"1a90cd07fe8aec7c15fd"}[chunkId] + ".css";
};